var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "web-app-detail-page" },
    [
      _c("AppBreadCrumb", {
        attrs: {
          paths: [
            { title: _vm.$t("message.integrations") },
            { title: "Web Apps", path: "/integrations/webapps" },
            { title: _vm.isEditMode ? "Düzenle" : "Yeni Web App" },
          ],
        },
      }),
      _vm._v(" "),
      _c(
        "a-card",
        { staticClass: "p-2", attrs: { loading: _vm.loading } },
        [
          _c("h2", [
            _vm._v(
              _vm._s(
                _vm.isEditMode ? "Web App Düzenle" : "Yeni Web App Oluştur"
              )
            ),
          ]),
          _vm._v(" "),
          _c(
            "a-card",
            {
              staticClass: "promo-card",
              staticStyle: { "margin-bottom": "24px" },
            },
            [
              _c("div", { staticClass: "supsis-code-promo" }, [
                _c("div", { staticClass: "promo-left" }, [
                  _c("div", { staticClass: "promo-icon" }, [
                    _c("span", { staticClass: "material-icons" }, [
                      _vm._v("code"),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "promo-text" }, [
                    _c("h3", [_vm._v("Supsis Code ile Geliştirin!")]),
                    _vm._v(" "),
                    _c("p", [
                      _vm._v(
                        "Sıfırdan React, Vue veya HTML projesi oluşturun. AI destekli kod editörü ile dakikalar içinde WebApp hazırlayın."
                      ),
                    ]),
                    _vm._v(" "),
                    _c("ul", [
                      _c("li", [_vm._v("✨ AI destekli kod tamamlama")]),
                      _vm._v(" "),
                      _c("li", [_vm._v("🎨 Hazır template'ler")]),
                      _vm._v(" "),
                      _c("li", [_vm._v("🚀 Otomatik build ve optimize")]),
                      _vm._v(" "),
                      _c("li", [_vm._v("📦 Direkt Supsis'e yükle")]),
                    ]),
                  ]),
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "promo-right" },
                  [
                    _c(
                      "a-button",
                      {
                        attrs: { type: "primary", size: "large" },
                        on: { click: _vm.openCodeSupsis },
                      },
                      [
                        _c("span", { staticClass: "material-icons" }, [
                          _vm._v("rocket_launch"),
                        ]),
                        _vm._v(
                          "\n                        code.supsis.ai'de Başla\n                    "
                        ),
                      ]
                    ),
                  ],
                  1
                ),
              ]),
            ]
          ),
          _vm._v(" "),
          _c(
            "a-alert",
            {
              staticStyle: { "margin-bottom": "24px" },
              attrs: {
                message: "Web App Yükleme Gereksinimleri",
                type: "info",
                "show-icon": "",
                closable: "",
              },
            },
            [
              _c("template", { slot: "description" }, [
                _c(
                  "ul",
                  { staticStyle: { margin: "8px 0", "padding-left": "20px" } },
                  [
                    _c("li", [
                      _c("strong", [_vm._v("index.html")]),
                      _vm._v(" veya "),
                      _c("strong", [_vm._v("index.htm")]),
                      _vm._v(" root dizinde zorunlu"),
                    ]),
                    _vm._v(" "),
                    _c("li", [
                      _vm._v("Maksimum dosya boyutu: "),
                      _c("strong", [_vm._v("100MB")]),
                    ]),
                    _vm._v(" "),
                    _c("li", [
                      _vm._v(
                        "Desteklenen: React build, Vue dist, Angular dist, statik HTML/CSS/JS"
                      ),
                    ]),
                    _vm._v(" "),
                    _c("li", [_vm._v("Slug global olarak unique olmalı")]),
                  ]
                ),
              ]),
            ],
            2
          ),
          _vm._v(" "),
          _c(
            "a-form",
            {
              attrs: { form: _vm.form },
              on: {
                submit: function ($event) {
                  $event.preventDefault()
                  return _vm.handleSubmit.apply(null, arguments)
                },
              },
            },
            [
              _c(
                "a-row",
                { attrs: { gutter: 16 } },
                [
                  _c(
                    "a-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "a-form-item",
                        { attrs: { label: "İkon" } },
                        [
                          _c("MaterialIconPicker", {
                            model: {
                              value: _vm.formData.icon,
                              callback: function ($$v) {
                                _vm.$set(_vm.formData, "icon", $$v)
                              },
                              expression: "formData.icon",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "a-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "a-form-item",
                        { attrs: { label: "İkon Rengi" } },
                        [
                          _c("color-picker", {
                            model: {
                              value: _vm.formData.iconColor,
                              callback: function ($$v) {
                                _vm.$set(_vm.formData, "iconColor", $$v)
                              },
                              expression: "formData.iconColor",
                            },
                          }),
                          _vm._v(" "),
                          _c("a-input", {
                            staticStyle: { "margin-top": "8px" },
                            attrs: { placeholder: "#6b727d" },
                            model: {
                              value: _vm.formData.iconColor,
                              callback: function ($$v) {
                                _vm.$set(_vm.formData, "iconColor", $$v)
                              },
                              expression: "formData.iconColor",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "a-form-item",
                { attrs: { label: "Web App Adı", required: "" } },
                [
                  _c("a-input", {
                    attrs: { placeholder: "Örn: CRM Dashboard" },
                    model: {
                      value: _vm.formData.name,
                      callback: function ($$v) {
                        _vm.$set(_vm.formData, "name", $$v)
                      },
                      expression: "formData.name",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "a-form-item",
                { attrs: { label: "Açıklama" } },
                [
                  _c("a-textarea", {
                    attrs: {
                      placeholder: "Web App'in ne yaptığını açıklayın",
                      rows: 3,
                    },
                    model: {
                      value: _vm.formData.description,
                      callback: function ($$v) {
                        _vm.$set(_vm.formData, "description", $$v)
                      },
                      expression: "formData.description",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "a-form-item",
                { attrs: { label: "Slug (Subdomain)", required: "" } },
                [
                  _c(
                    "a-input",
                    {
                      attrs: { placeholder: "ornek-webapp" },
                      on: {
                        input: _vm.handleSlugInput,
                        blur: _vm.checkSlugAvailability,
                      },
                      model: {
                        value: _vm.formData.slug,
                        callback: function ($$v) {
                          _vm.$set(_vm.formData, "slug", $$v)
                        },
                        expression: "formData.slug",
                      },
                    },
                    [
                      _vm.slugStatus
                        ? _c("a-icon", {
                            style: {
                              color:
                                _vm.slugStatus === "available"
                                  ? "#52c41a"
                                  : "#f5222d",
                            },
                            attrs: {
                              slot: "suffix",
                              type:
                                _vm.slugStatus === "available"
                                  ? "check-circle"
                                  : "close-circle",
                            },
                            slot: "suffix",
                          })
                        : _vm.checkingSlug
                        ? _c("a-icon", {
                            attrs: { slot: "suffix", type: "loading" },
                            slot: "suffix",
                          })
                        : _vm._e(),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "slug-info" }, [
                    _vm._v("\n                    URL: "),
                    _c("strong", [
                      _vm._v(
                        _vm._s(_vm.formData.slug || "slug") +
                          ".webapp.supsis.ai"
                      ),
                    ]),
                  ]),
                  _vm._v(" "),
                  _vm.slugError
                    ? _c("div", { staticClass: "slug-error" }, [
                        _c("span", { staticClass: "material-icons" }, [
                          _vm._v("error"),
                        ]),
                        _vm._v(
                          "\n                    " +
                            _vm._s(_vm.slugError) +
                            "\n                "
                        ),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _c("div", { staticClass: "slug-rules" }, [
                    _c("small", [
                      _vm._v(
                        "\n                        Sadece küçük harf, rakam ve tire (-) kullanılabilir. Min 3, max 63 karakter.\n                    "
                      ),
                    ]),
                  ]),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "a-form-item",
                { attrs: { label: "Version" } },
                [
                  _c("a-input", {
                    staticStyle: { width: "200px" },
                    attrs: { placeholder: "1.0.0" },
                    model: {
                      value: _vm.formData.version,
                      callback: function ($$v) {
                        _vm.$set(_vm.formData, "version", $$v)
                      },
                      expression: "formData.version",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _vm.isSupsisSite
                ? _c(
                    "a-form-item",
                    { attrs: { label: "Public Yap" } },
                    [
                      _c(
                        "a-switch",
                        {
                          model: {
                            value: _vm.formData.isPublic,
                            callback: function ($$v) {
                              _vm.$set(_vm.formData, "isPublic", $$v)
                            },
                            expression: "formData.isPublic",
                          },
                        },
                        [
                          _c(
                            "span",
                            {
                              attrs: { slot: "checkedChildren" },
                              slot: "checkedChildren",
                            },
                            [_vm._v("Public")]
                          ),
                          _vm._v(" "),
                          _c(
                            "span",
                            {
                              attrs: { slot: "unCheckedChildren" },
                              slot: "unCheckedChildren",
                            },
                            [_vm._v("Private")]
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticStyle: {
                            "font-size": "12px",
                            color: "#999",
                            "margin-top": "4px",
                          },
                        },
                        [
                          _vm._v(
                            "\n                    Public yapılan app'ler tüm Supsis sitelerinde görünür\n                "
                          ),
                        ]
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "a-form-item",
                {
                  attrs: {
                    label: "Proje Dosyası (Zip)",
                    required: !_vm.isEditMode,
                  },
                },
                [
                  _c(
                    "a-upload-dragger",
                    {
                      attrs: {
                        "before-upload": _vm.beforeUpload,
                        "custom-request": _vm.customUpload,
                        accept: ".zip",
                        "show-upload-list": false,
                        disabled: _vm.uploading,
                      },
                    },
                    [
                      _c("p", { staticClass: "ant-upload-drag-icon" }, [
                        _c("span", { staticClass: "material-icons" }, [
                          _vm._v(
                            _vm._s(
                              _vm.uploadedFile ? "check_circle" : "upload_file"
                            )
                          ),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c("p", { staticClass: "ant-upload-text" }, [
                        _vm._v(
                          "\n                        " +
                            _vm._s(
                              _vm.uploadedFile
                                ? _vm.uploadedFile.name
                                : "Zip dosyasını sürükleyin veya tıklayın"
                            ) +
                            "\n                    "
                        ),
                      ]),
                      _vm._v(" "),
                      _c("p", { staticClass: "ant-upload-hint" }, [
                        _vm._v(
                          "\n                        " +
                            _vm._s(
                              _vm.isEditMode
                                ? "Yeni zip yüklemek mevcut dosyaların üzerine yazacak"
                                : "Maksimum 100MB, sadece .zip dosyası"
                            ) +
                            "\n                    "
                        ),
                      ]),
                    ]
                  ),
                  _vm._v(" "),
                  _vm.uploading
                    ? _c("a-progress", {
                        staticStyle: { "margin-top": "16px" },
                        attrs: {
                          percent: _vm.displayUploadProgress,
                          status: "active",
                        },
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.formData.metadata && _vm.formData.metadata.fileCount
                    ? _c(
                        "div",
                        { staticClass: "upload-info" },
                        [
                          _c(
                            "a-alert",
                            { attrs: { type: "success", "show-icon": "" } },
                            [
                              _c("template", { slot: "message" }, [
                                _vm._v(
                                  "\n                            Proje Yüklendi: " +
                                    _vm._s(_vm.formData.metadata.fileCount) +
                                    " dosya\n                            (" +
                                    _vm._s(
                                      _vm.formatSize(
                                        _vm.formData.metadata.totalSize
                                      )
                                    ) +
                                    ")\n                            "
                                ),
                                _vm.formData.metadata.uploadedAt
                                  ? _c("span", [
                                      _vm._v(
                                        "\n                                - " +
                                          _vm._s(
                                            _vm
                                              .$moment(
                                                _vm.formData.metadata.uploadedAt
                                              )
                                              .fromNow()
                                          ) +
                                          "\n                            "
                                      ),
                                    ])
                                  : _vm._e(),
                              ]),
                            ],
                            2
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "a-form-item",
                { attrs: { label: "Default Query Parametreleri" } },
                [
                  _c(
                    "div",
                    { staticClass: "query-params-section" },
                    [
                      _c("p", { staticClass: "query-params-hint" }, [
                        _vm._v(
                          "\n                        Bu uygulama web sekmesi olarak kurulduğunda otomatik eklenecek URL parametreleri\n                    "
                        ),
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "query-params-list" },
                        _vm._l(
                          _vm.formData.defaultQueryParams,
                          function (param, index) {
                            return _c(
                              "div",
                              { key: index, staticClass: "query-param-row" },
                              [
                                _c("a-input", {
                                  staticStyle: { width: "120px" },
                                  attrs: { placeholder: "Key", size: "small" },
                                  model: {
                                    value: param.key,
                                    callback: function ($$v) {
                                      _vm.$set(param, "key", $$v)
                                    },
                                    expression: "param.key",
                                  },
                                }),
                                _vm._v(" "),
                                _c("span", { staticClass: "param-equals" }, [
                                  _vm._v("="),
                                ]),
                                _vm._v(" "),
                                _c("a-input", {
                                  staticStyle: { flex: "1" },
                                  attrs: {
                                    placeholder: "Value veya ${dinamik}",
                                    size: "small",
                                  },
                                  model: {
                                    value: param.value,
                                    callback: function ($$v) {
                                      _vm.$set(param, "value", $$v)
                                    },
                                    expression: "param.value",
                                  },
                                }),
                                _vm._v(" "),
                                _c(
                                  "a-select",
                                  {
                                    staticStyle: { width: "140px" },
                                    attrs: {
                                      placeholder: "Dinamik",
                                      size: "small",
                                    },
                                    on: {
                                      change: function (val) {
                                        return _vm.handleDynamicValueChange(
                                          index,
                                          val
                                        )
                                      },
                                    },
                                    model: {
                                      value: param.dynamicValue,
                                      callback: function ($$v) {
                                        _vm.$set(param, "dynamicValue", $$v)
                                      },
                                      expression: "param.dynamicValue",
                                    },
                                  },
                                  [
                                    _c(
                                      "a-select-opt-group",
                                      { attrs: { label: "Manuel" } },
                                      [
                                        _c(
                                          "a-select-option",
                                          { attrs: { value: "" } },
                                          [_vm._v("Manuel")]
                                        ),
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "a-select-opt-group",
                                      { attrs: { label: "Kullanıcı" } },
                                      [
                                        _c(
                                          "a-select-option",
                                          { attrs: { value: "${user.name}" } },
                                          [_vm._v("Adı")]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "a-select-option",
                                          { attrs: { value: "${user.email}" } },
                                          [_vm._v("Email")]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "a-select-option",
                                          { attrs: { value: "${user.id}" } },
                                          [_vm._v("ID")]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "a-select-option",
                                          { attrs: { value: "${user.token}" } },
                                          [_vm._v("Token")]
                                        ),
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "a-select-opt-group",
                                      { attrs: { label: "Site" } },
                                      [
                                        _c(
                                          "a-select-option",
                                          { attrs: { value: "${site.id}" } },
                                          [_vm._v("Site ID")]
                                        ),
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "a-select-opt-group",
                                      { attrs: { label: "Kişi" } },
                                      [
                                        _c(
                                          "a-select-option",
                                          { attrs: { value: "${contact.id}" } },
                                          [_vm._v("ID")]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "a-select-option",
                                          {
                                            attrs: {
                                              value: "${contact.fullname}",
                                            },
                                          },
                                          [_vm._v("Ad Soyad")]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "a-select-option",
                                          {
                                            attrs: {
                                              value: "${contact.email}",
                                            },
                                          },
                                          [_vm._v("E-posta")]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "a-select-option",
                                          {
                                            attrs: {
                                              value: "${contact.phone}",
                                            },
                                          },
                                          [_vm._v("Telefon")]
                                        ),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "a-button",
                                  {
                                    staticClass: "remove-param-btn",
                                    attrs: { type: "link", size: "small" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.removeQueryParam(index)
                                      },
                                    },
                                  },
                                  [
                                    _c(
                                      "span",
                                      { staticClass: "material-icons" },
                                      [_vm._v("close")]
                                    ),
                                  ]
                                ),
                              ],
                              1
                            )
                          }
                        ),
                        0
                      ),
                      _vm._v(" "),
                      _c(
                        "a-button",
                        {
                          staticClass: "add-param-btn",
                          attrs: { type: "dashed", size: "small" },
                          on: { click: _vm.addQueryParam },
                        },
                        [
                          _c("span", { staticClass: "material-icons" }, [
                            _vm._v("add"),
                          ]),
                          _vm._v(
                            "\n                        Parametre Ekle\n                    "
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                ]
              ),
              _vm._v(" "),
              _c(
                "a-form-item",
                { attrs: { label: "Durum" } },
                [
                  _c(
                    "a-switch",
                    {
                      model: {
                        value: _vm.formData.enabled,
                        callback: function ($$v) {
                          _vm.$set(_vm.formData, "enabled", $$v)
                        },
                        expression: "formData.enabled",
                      },
                    },
                    [
                      _c(
                        "span",
                        {
                          attrs: { slot: "checkedChildren" },
                          slot: "checkedChildren",
                        },
                        [_vm._v("Aktif")]
                      ),
                      _vm._v(" "),
                      _c(
                        "span",
                        {
                          attrs: { slot: "unCheckedChildren" },
                          slot: "unCheckedChildren",
                        },
                        [_vm._v("Pasif")]
                      ),
                    ]
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "a-form-item",
                [
                  _c(
                    "a-space",
                    [
                      _c(
                        "a-button",
                        {
                          attrs: {
                            type: "primary",
                            "html-type": "submit",
                            loading: _vm.saving,
                            disabled: _vm.uploading,
                          },
                        },
                        [
                          _vm._v(
                            "\n                        " +
                              _vm._s(_vm.isEditMode ? "Güncelle" : "Oluştur") +
                              "\n                    "
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "a-button",
                        {
                          on: {
                            click: function ($event) {
                              return _vm.$router.push("/integrations/webapps")
                            },
                          },
                        },
                        [_vm._v("İptal")]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }